import { resolve_seo_name } from '@/utils/main_utils'
import Availability from '@/helpers/Availability'
import { Item } from '@/helpers/Item'
import axios from '@/utils/axios_iface'

export default {
  state: {
    selectedCategory: undefined,
    rawMenuItems: undefined,
    menuItems: undefined,
    menuItemsStatus: 'inprocess',
    searchItem: false,
    lookups: {},
  },
  getters: {
    availableByLocation: (state, getters) => (item) => {
      //first check in category and sub category to which this item belongs
      //if those category or subcategory doesn't exist in this location then return false
      if (item.category) {
        const category = getters.find_store_item_category_by_main_id(
          item.category
        )
        if (
          !Availability.availableInLocation(
            category,
            getters.selectedCountry,
            getters.priceCity,
            getters.currentStoreId
          )
        ) {
          return false
        }
      }
      if (item.sub_category) {
        const subcategory = getters.find_store_item_subcategory_by_main_id(
          item.sub_category
        )
        if (
          !Availability.availableInLocation(
            subcategory,
            getters.selectedCountry,
            getters.priceCity,
            getters.currentStoreId
          )
        ) {
          return false
        }
      }

      if (item.modifier_group) {
        const group = getters.find_item_modifier_group_by_main_id(
          item.modifier_group
        )
        if (
          !Availability.availableInLocation(
            group,
            getters.selectedCountry,
            getters.priceCity,
            getters.currentStoreId
          )
        ) {
          return false
        }
      }

      if (item.modifier_sub_group) {
        const subgroup = getters.find_item_modifier_subgroup_by_main_id(
          item.modifier_sub_group
        )
        if (
          !Availability.availableInLocation(
            subgroup,
            getters.selectedCountry,
            getters.priceCity,
            getters.currentStoreId
          )
        ) {
          return false
        }
      }

      if (
        Availability.availableInLocation(
          item,
          getters.selectedCountry,
          getters.priceCity,
          getters.currentStoreId
        )
      ) {
        return true
      }
      return false
    },

    availabeByTime: (state, getters) => (item) => {
      if (getters.selectedTimezone) {
        if (Availability.available(item, getters.selectedTimezone)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },

    availableValue: (state, getters) => (itemAvailability) => {
      return Availability.availableValue(
        itemAvailability,
        getters.selectedCountry,
        getters.priceCity,
        getters.currentStoreId
      )
    },

    available_menu_items: (state, getters) =>
      state.rawMenuItems.filter((item) => getters.availabeByTime(item)),
    lookups: (state) => state.lookups,
    tax_sum:
      (state, getters) =>
      (taxIds, entityName = 'menu_items') => {
        const lookup = getters.lookups[entityName]
        const taxes = []
        if (lookup['brand_tax_rates']) {
          taxIds.forEach((taxId) => {
            if (
              lookup['brand_tax_rates'] &&
              lookup['brand_tax_rates']._id[taxId]
            ) {
              taxes.push(lookup['brand_tax_rates']._id[taxId])
            }
          })
        }
        return taxes.reduce((total, tax) => {
          total += getters.availableValue(tax.price_availability)
          return total
        }, 0)
      },

    searchItem: (state) => {
      return state.searchItem
    },
    all_store_menu_items: (state, getters) => {
      return Object.freeze(getters.available_menu_items)
    },
    all_store_menu_items_being_loaded: (state) =>
      state.menuItemsStatus === 'inprocess',

    find_store_menu_item_by_main_id: (state, getters) => (id) =>
      getters.available_menu_items
        ? getters.available_menu_items.find((item) => item._id === id)
        : undefined,

    find_store_menu_item_by_slug: (state, getters) => (slug) =>
      getters.available_menu_items
        ? getters.available_menu_items.find((item) => item.slug === slug)
        : undefined,

    discounted_menu_price: (state, getters) => (menuItem) => {
      let menuprice = menuItem.value
      if (menuItem.menuDiscounts && !menuItem.menuDiscounts.length) {
        return menuprice
      }
      if (menuItem.menuDiscounts) {
        menuItem.menuDiscounts.forEach((discount) => {
          //keep applying discount until price drops to zero
          if (discount.price && menuprice - discount.price >= 0) {
            menuprice -= discount.price + discount.tax
          }
        })
      }
      Object.freeze(menuprice)
      return menuprice
    },
    discounted_modifiers_price:
      (state, getters) => (menuItem, modifiersPrice) => {
        return modifiersPrice
      },

    quick_view_menu_items_prepared: (state, getters) => (params) => {
      return getters
        .quick_view_store_menu_items(params)
        .map((item) => getters.prepare_menu_item(item))
    },
    menu_items: (state, getters) => {
      let items = []
      if (!getters.all_store_menu_items) {
        return items
      }
      if (state.searchItem) {
        getters.all_store_menu_items.forEach((menuItem) => {
          let item = { ...menuItem }
          let item_prepare = getters.prepare_menu_item(item)
          let arabicRegex = /[\u0600-\u06FF]/

          Object.freeze(item_prepare)
          if (
            getters.currentLanguage !== 'en-US' &&
            arabicRegex.test(state.searchItem)
          ) {
            let item_name =
              item_prepare.translations_dict &&
              item_prepare.translations_dict.name &&
              item_prepare.translations_dict.name[getters.currentLanguage]
                ? item_prepare.translations_dict.name[getters.currentLanguage]
                : false
            if (
              item_name &&
              (item_name.includes(state.searchItem) ||
                state.searchItem == item_name)
            ) {
              items.push(item_prepare)
            }
          } else {
            const searchKey = state.searchItem.toLowerCase()
            if (
              item_prepare.name &&
              item_prepare.name.toLowerCase().includes(searchKey)
            ) {
              items.push(item_prepare)
            }
          }
        })
      } else {
        items = getters.all_store_menu_items.map((menuItem) => {
          let item = { ...menuItem }
          return getters.prepare_menu_item(item)
        })
        Object.freeze(items)
      }
      let filtered_item = []
      items.forEach((item) => {
        if (item.value !== null) {
          filtered_item.push(item)
        }
      })
      return Object.freeze(filtered_item)
      //apply item discounts on the items
    },
    prepare_menu_item: (state, getters) => (item) => {
      // let currency = getters.get_currencies
      //  item.original_value = item.value
      //  item = getters.item_price_set_currency(item)
      item.value = getters.availableValue(item.price_availability)
      item.tax_sum = getters.tax_sum(item.applicable_taxes)

      item.netPrice = Item.itemNetPrice(item)
      item.tax = Item.tax(item.netPrice, item.tax_sum)

      item.rounded = {
        netPrice: Item.itemNetPrice(item, true),
        tax: Item.tax(item.netPrice, item.tax_sum, true),
      }

      item.menuDiscounts = []
      item.cartDiscounts = []

      getters.item_discounts(item).forEach((discount) => {
        item.menuDiscounts.push({ ...discount })
      })
      Object.freeze(item.menuDiscounts)
      //apply discount calculations for menu items not cart
      item = Item.applyMenuDiscounts(item)

      Object.freeze(item)
      return item
    },
    item_discounts: (state, getters) => (item) =>
      Object.freeze(
        getters.all_item_discounts.filter((discount) => {
          if (discount[getters.order_type]) {
            if (discount.for_items.includes(item._id)) {
              let discs = getters.availabeByTime(discount)
              Object.freeze(discs)
              return discs
            }
          }
        })
      ),
    selected_category: (state) => state.selectedCategory,
    sub_categories: (state, getters) => (categoryId) =>
      Object.freeze(
        getters.all_store_subcategories.filter(
          (subcat) => subcat.category === categoryId
        )
      ),
    category_products: (state, getters) => (categoryId) => {
      if (!categoryId) {
        categoryId =
          (state.selectedCategory && state.selectedCategory._id) ||
          (getters.all_store_categories.length &&
            getters.all_store_categories[0]._id)
      }
      if (!categoryId) {
        return Object.freeze(getters.menu_items)
      }

      const subcategories = Object.freeze(getters.sub_categories(categoryId))
      //if category has subcategories, you can not assign a product to category, you have to select a subcat
      if (subcategories && subcategories.length) {
        let menuItems = []
        subcategories.forEach((subcat) => {
          const subcatMenuItems = Object.freeze(
            getters.menu_items.filter(
              (item) =>
                item.sub_category === subcat._id &&
                item.item_type !== 'combo_item'
            )
          )
          menuItems = Object.freeze([...menuItems, ...subcatMenuItems])
        })
        return menuItems
      } else {
        return Object.freeze(
          getters.menu_items.filter(
            (menu_item) =>
              menu_item.category == categoryId &&
              menu_item.item_type !== 'combo_item'
          )
        )
      }
    },
    hasModifiers: (state, getters) => (item) =>
      getters.all_item_modifier_groups.some((group) =>
        group.for_items.includes(item._id)
      ),
    itemModifierGroups: (state, getters) => (item) => {
      if (!item) return false
      return Object.freeze(
        getters.all_item_modifier_groups.filter((group) =>
          group.for_items.includes(item._id)
        )
      )
    },

    itemModifierSubgroupsByGroup: (state, getters) => (group) =>
      Object.freeze(
        getters.all_item_modifier_subgroups.filter((subgroup) =>
          subgroup.modifier_group.includes(group._id)
        )
      ),
    itemModifiersByGroupSubGroup: (state, getters) => (group, subgroup) =>
      Object.freeze(
        getters.all_item_modifiers.filter(
          (modifier) =>
            modifier.modifier_group == group._id &&
            modifier.modifier_sub_group == subgroup._id
        )
      ),

    modifiersInSubgroup: (state, getters) => (group, subgroup) =>
      getters.all_item_modifiers.some(
        (modifier) =>
          modifier.modifier_group == group._id &&
          modifier.modifier_sub_group == subgroup._id
      ),
    getSearchTerm: (state) => state.searchTerm,
    all_item_modifiers: (state, getters) => {
      return (
        getters.all_raw_item_modifiers
          // .filter(
          //   modifier => getters.availableByLocation(modifier)
          // )
          .map((modifier) => {
            modifier.value = getters.availableValue(modifier.price_availability)
            return modifier
          })
      )
    },
    all_payment_types: (state, getters) => {
      return getters.all_raw_payment_types.filter((payment) =>
        getters.availableByLocation(payment)
      )
    },
    all_item_discounts: (state, getters) => {
      return getters.all_raw_item_discounts.filter(
        (item) =>
          getters.availableByLocation(item) && getters.availabeByTime(item)
      )
    },
    all_order_discounts: (state, getters) => {
      return getters.all_raw_order_discounts.filter(
        (item) =>
          getters.availableByLocation(item) && getters.availabeByTime(item)
      )
    },
    all_additional_surcharges: (state, getters) => {
      return getters.all_raw_additional_surcharges
        .filter((item) => getters.availableByLocation(item))
        .map((item) => {
          item.tax_sum = getters.tax_sum(
            item.applicable_taxes,
            'additional_surcharges'
          )
          return item
        })
    },
    all_store_categories: (state, getters) => {
      return getters.all_raw_store_categories
      //.filter(item => getters.availableByLocation(item))
    },
    all_store_subcategories: (state, getters) => {
      return getters.all_raw_store_subcategories
      //.filter(item => getters.availableByLocation(item))
    },
  },
  actions: {
    set_additonal_surcharge_lookups({ commit }, response) {
      commit('SET_LOOKUPS', {
        entity: 'additional_surcharges',
        lookup: response.page_lookups,
      })
    },
    async loadCatalog({ dispatch, commit }) {
      commit('SET_ITEM_SEARCH_TERM', false)
      return Promise.allSettled([
        dispatch('load_brand_menu_items'),
        dispatch('load_brand_item_categories'),
        dispatch('load_brand_item_subcategories'),
        dispatch('load_brand_item_modifier_groups'),
        dispatch('load_brand_item_modifier_subgroups'),
        dispatch('load_brand_item_modifiers'),
        dispatch('load_brand_item_discounts'),
        dispatch('load_brand_order_discounts'),
        dispatch('load_brand_additional_surcharges'),
        dispatch('load_brand_payment_types'),
      ])
    },
    async load_brand_menu_items({ getters, commit, dispatch }) {
      commit('SET_MENU_ITEMS_BEING_LOADED', 'inprocess')
      const url = getters.brand_api_base.replace('/api', '/cached/api')
      const version = getters.getVersion({
        data: {
          collection_id: 'brand_menu_items',
        },
      })
      let result = await axios.get(
        `${url}/model/brand_menu_items?byColumn=1&page_id=brand_menu_items_main_tbl&item_type=regular&shown_web=true&item_status=true&no_limit=true&lookups_needed=1&min_max_needed=0&fetch_version=${version}`
      )
      if (result.data && result.data.status === 'loaded') {
        //populate data
        commit('SET_LOOKUPS', {
          entity: 'menu_items',
          lookup: result.data.page_lookups,
        })
        commit('SET_RAW_MENU_ITEMS', result.data.data)
        dispatch('resolveProduct')
        dispatch('restoreCart')
      }
      commit('SET_MENU_ITEMS_BEING_LOADED', undefined)
    },

    resolveCategory: ({ commit, getters }, categoryName) => {
      const category = getters.all_store_categories.find(
        (cat) => cat.name.toLowerCase() == resolve_seo_name(categoryName)
      )
      commit('SELECT_CATEGORY', category)
    },

    resolveProduct: ({ commit, getters }) => {
      let product_slug = getters.productSlug
      if (!product_slug) return false
      let item = getters.menu_items.find((item) => item.slug === product_slug)
      commit('SELECT_MODIFIERS', {})
      if (item) {
        commit('SELECT_ITEM', item)
        //commit('ADD_ITEM_TO_CART', prepared_item)
        commit('PRODUCT_DETAILS_PAGE', true)
      }
      // commit('SET_ITEM_DETAIL_POPUP', true)
    },
  },
  mutations: {
    SELECT_CATEGORY: (state, category) => {
      state.selectedCategory = category
    },
    SET_RAW_MENU_ITEMS: (state, items) =>
      (state.rawMenuItems = Object.freeze(items)),
    SET_MENU_ITEMS_BEING_LOADED: (state, status) =>
      (state.menuItemsStatus = status),
    SET_ITEM_SEARCH_TERM: (state, term) => (state.searchItem = term),
    SET_LOOKUPS: (state, { entity, lookup }) => {
      state.lookups[entity] = lookup
    },
  },
}
